module.exports = __webpack_public_path__ + "img/健康预警机器人ppt-18.f766eacd.jpg";